export const HMRC_ACCOUNT_LINK = 'https://www.tax.service.gov.uk/personal-account/self-assessment-summary'
export const HMRC_INSTRUCTIONS_LINK = 'https://www.gov.uk/pay-self-assessment-tax-bill'

export const INVOICES_EXPENSES_SPREADSHEET_LINK =
    'https://taxscoutsassets.blob.core.windows.net/documents/Invoices_and_expenses_template.xlsx'

export const HIGH_EARNER_SALARY_THRESHOLD = 100000

export const SELF_ASSESSMENT_STATUS_CREATED = 'Created'
export const SELF_ASSESSMENT_STATUS_DRAFTED = 'Drafted'
export const SELF_ASSESSMENT_STATUS_STARTED = 'Started'
export const SELF_ASSESSMENT_STATUS_UPLOADING_DOCUMENTS = 'UploadingDocuments'
export const SELF_ASSESSMENT_STATUS_SUBMITTED = 'Submitted'
export const SELF_ASSESSMENT_STATUS_PROCESSING_DOCUMENTS = 'ProcessingDocuments'
export const SELF_ASSESSMENT_STATUS_ACCOUNTANT_REVIEW = 'AccountantReview'
export const SELF_ASSESSMENT_STATUS_INFORMATION_REQUIRED = 'InformationRequired'
export const SELF_ASSESSMENT_STATUS_AWAITING_CUSTOMER_APPROVAL = 'AwaitingCustomerApproval'
export const SELF_ASSESSMENT_STATUS_CUSTOMER_CORRECTIONS = 'CustomerCorrections'
export const SELF_ASSESSMENT_STATUS_CANCELLED = 'Cancelled'
export const SELF_ASSESSMENT_STATUS_READY_TO_FILE = 'ReadyToFile'
export const SELF_ASSESSMENT_STATUS_FILED_AWAITING_REFUND = 'FiledAwaitingRefund'
export const SELF_ASSESSMENT_STATUS_FILED = 'Filed'
export const SELF_ASSESSMENT_STATUS_COMPLETED_NOT_FILED = 'CompletedNotFiled'

export const SELF_ASSESSMENT_STATUS_ORDER = {
    [SELF_ASSESSMENT_STATUS_CREATED]: 0,
    [SELF_ASSESSMENT_STATUS_DRAFTED]: 5,
    [SELF_ASSESSMENT_STATUS_STARTED]: 10,
    [SELF_ASSESSMENT_STATUS_UPLOADING_DOCUMENTS]: 20,
    [SELF_ASSESSMENT_STATUS_SUBMITTED]: 30,
    [SELF_ASSESSMENT_STATUS_PROCESSING_DOCUMENTS]: 40,
    [SELF_ASSESSMENT_STATUS_ACCOUNTANT_REVIEW]: 50,
    [SELF_ASSESSMENT_STATUS_INFORMATION_REQUIRED]: 60,
    [SELF_ASSESSMENT_STATUS_AWAITING_CUSTOMER_APPROVAL]: 70,
    [SELF_ASSESSMENT_STATUS_CUSTOMER_CORRECTIONS]: 80,
    [SELF_ASSESSMENT_STATUS_CANCELLED]: 85,
    [SELF_ASSESSMENT_STATUS_READY_TO_FILE]: 90,
    [SELF_ASSESSMENT_STATUS_COMPLETED_NOT_FILED]: 93,
    [SELF_ASSESSMENT_STATUS_FILED_AWAITING_REFUND]: 95,
    [SELF_ASSESSMENT_STATUS_FILED]: 100,
}

export const SELF_ASSESSMENT_STATUS_TITLES = {
    [SELF_ASSESSMENT_STATUS_CREATED]: 'Ready to start',
    [SELF_ASSESSMENT_STATUS_DRAFTED]: 'Drafted',
    [SELF_ASSESSMENT_STATUS_STARTED]: 'Started',
    [SELF_ASSESSMENT_STATUS_UPLOADING_DOCUMENTS]: 'Uploading documents',
    [SELF_ASSESSMENT_STATUS_SUBMITTED]: 'Will be prepared',
    [SELF_ASSESSMENT_STATUS_PROCESSING_DOCUMENTS]: 'Processing',
    [SELF_ASSESSMENT_STATUS_ACCOUNTANT_REVIEW]: 'Being prepared',
    [SELF_ASSESSMENT_STATUS_INFORMATION_REQUIRED]: 'Information required',
    [SELF_ASSESSMENT_STATUS_AWAITING_CUSTOMER_APPROVAL]: 'Waiting your approval',
    [SELF_ASSESSMENT_STATUS_CUSTOMER_CORRECTIONS]: 'Making corrections',
    [SELF_ASSESSMENT_STATUS_CANCELLED]: 'Cancelled',
    [SELF_ASSESSMENT_STATUS_READY_TO_FILE]: 'Will be filed',
    [SELF_ASSESSMENT_STATUS_FILED_AWAITING_REFUND]: 'Filed',
    [SELF_ASSESSMENT_STATUS_FILED]: 'Filed',
    [SELF_ASSESSMENT_STATUS_COMPLETED_NOT_FILED]: 'Completed, not filed',
}

export const REASON_EARNINGS_LIMIT = 'EarningsLimit'
export const REASON_SELF_EMPLOYMENT = 'SelfEmployment'
export const REASON_PROPERTY_INCOME = 'PropertyIncome'
export const REASON_DIVIDENDS_AND_INTEREST = 'DividendsAndInterest'
export const REASON_CAPITAL_GAINS = 'CapitalGains'
export const REASON_COMPANY_DIRECTOR = 'CompanyDirector'
export const REASON_HMRC_LETTER = 'HmrcLetter'
export const REASON_TAX_REFUND = 'TaxRefund'
export const REASON_OTHER = 'Other'
export const REASON_FOREIGN_INCOME = 'ForeignIncome'

export const SECTION_STATUS_NOT_STARTED = 'NotStarted'
export const SECTION_STATUS_CONFIRMING_DATA = 'ConfirmingData'
export const SECTION_STATUS_INCOMPLETE = 'Incomplete'
export const SECTION_STATUS_QUESTIONS_COMPLETED = 'QuestionsCompleted'
export const SECTION_STATUS_UPLOADS_COMPLETED = 'UploadsCompleted'

export const SECTION_STATUS_ORDER = {
    [SECTION_STATUS_NOT_STARTED]: 0,
    [SECTION_STATUS_CONFIRMING_DATA]: 5,
    [SECTION_STATUS_INCOMPLETE]: 10,
    [SECTION_STATUS_QUESTIONS_COMPLETED]: 20,
    [SECTION_STATUS_UPLOADS_COMPLETED]: 30,
}

export const SELF_EMPLOYMENT_CATEGORY_FREELANCER = 'Freelancer'
export const SELF_EMPLOYMENT_CATEGORY_CONSTRUCTION = 'Construction'
export const SELF_EMPLOYMENT_CATEGORY_DRIVER = 'Driver'
export const SELF_EMPLOYMENT_CATEGORY_OTHER = 'Other'

export const SELF_EMPLOYMENT_CATEGORY_TITLES = {
    [SELF_EMPLOYMENT_CATEGORY_FREELANCER]: 'Freelance or contract work',
    [SELF_EMPLOYMENT_CATEGORY_CONSTRUCTION]: 'Construction (CIS)',
    [SELF_EMPLOYMENT_CATEGORY_DRIVER]: 'Courier or driver',
    [SELF_EMPLOYMENT_CATEGORY_OTHER]: 'Other',
}

export const SELF_EMPLOYMENT_EXPENSE_TOOLS = 'Tools'
export const SELF_EMPLOYMENT_EXPENSE_PHONE = 'PhoneAndInternet'
export const SELF_EMPLOYMENT_EXPENSE_TRANSPORT = 'PublicTransport'
export const SELF_EMPLOYMENT_EXPENSE_OTHER = 'Other'

export const BUSINESS_VEHICLE_OWNERSHIP_OWNS = 'Owns'
export const BUSINESS_VEHICLE_OWNERSHIP_RENTS = 'Rents'
export const BUSINESS_VEHICLE_OWNERSHIP_LEASES = 'Leases'

export const BUSINESS_VEHICLE_TYPE_BICYCLE = 'Bicycle'
export const BUSINESS_VEHICLE_TYPE_CAR = 'Car'
export const BUSINESS_VEHICLE_TYPE_MOTORBIKE = 'Motorbike'
export const BUSINESS_VEHICLE_TYPE_VAN = 'Van'

export const FILING_AREA_GENERAL = 'General'
export const FILING_AREA_EMPLOYMENT = 'Employment'
export const FILING_AREA_SELF_EMPLOYMENT = 'SelfEmployment'
export const FILING_AREA_CAPITAL_GAINS = 'CapitalGains'
export const FILING_AREA_PROPERTY = 'Property'
export const FILING_AREA_DIVIDENDS_AND_INTEREST = 'DividendsAndInterest'
export const FILING_AREA_PENSIONS_AND_BENEFITS = 'PensionsAndBenefits'
export const FILING_AREA_FOREIGN_INCOME = 'ForeignIncome'
export const FILING_AREA_OTHER_INCOME = 'OtherIncome'
export const FILING_AREA_PENSIONS_CONTRIBUTIONS = 'PensionsContributions'
export const FILING_AREA_CHARITABLE_GIVING = 'CharitableGiving'
export const FILING_AREA_STUDENT_LOANS = 'StudentLoans'
export const FILING_AREA_INVESTMENT_SCHEME = 'InvestmentScheme'

export const FILING_AREA_TITLES = {
    [FILING_AREA_GENERAL]: 'Tax returns & calculations',
    [FILING_AREA_EMPLOYMENT]: 'Employment',
    [FILING_AREA_SELF_EMPLOYMENT]: 'Self-employment',
    [FILING_AREA_CAPITAL_GAINS]: 'Capital gains',
    [FILING_AREA_PROPERTY]: 'Property earnings',
    [FILING_AREA_DIVIDENDS_AND_INTEREST]: 'Dividends and interest',
    [FILING_AREA_PENSIONS_AND_BENEFITS]: 'Pensions or benefits',
    [FILING_AREA_FOREIGN_INCOME]: 'Foreign income',
    [FILING_AREA_OTHER_INCOME]: 'Other income',
    [FILING_AREA_PENSIONS_CONTRIBUTIONS]: 'Pensions contributions',
    [FILING_AREA_CHARITABLE_GIVING]: 'Charitable donations',
    [FILING_AREA_STUDENT_LOANS]: 'Student loans',
    [FILING_AREA_INVESTMENT_SCHEME]: 'Investment schemes',
}

export const ALLOWANCE_PAYMENTS_ON_ACCOUNT = 'paymentsOnAccount'
export const ALLOWANCE_PENSIONS_CONTRIBUTIONS = 'pensionsContributions'
export const ALLOWANCE_CHARITABLE_DONATIONS = 'charitableDonations'
export const ALLOWANCE_STUDENT_LOAN_REPAYMENTS = 'studentLoan'

export const EMPLOYER_BENEFIT_TYPE_TITLES = {
    CompanyCarsAndVansBenefit: 'Company cars and vans',
    FuelForCompanyCarsAndVansBenefit: 'Fuel for company cars and vans',
    PrivateMedicalDentalInsurance: 'Private medical and dental insurance',
    VouchersCreditCardsExcessMileageAllowance: 'Vouchers, credit cards and excess mileage allowance',
    GoodsEtcProvidedByEmployer: 'Goods and other assets by your employer',
    AccommodationProvidedByEmployer: 'Accommodation provided by your employer',
    OtherBenefits: 'Other benefits (including interest-free and low interest loans)',
    ExpensesPaymentsReceived: 'Expenses payments received and balancing charges',
}

export const MORTGAGE_TYPE_INTEREST_ONLY = 'InterestOnly'
export const MORTGAGE_TYPE_REPAYMENT = 'Repayment'
export const MORTGAGE_TYPE_UNKNOWN = 'Unknown'

export const MORTGAGE_TYPE_TITLES = {
    [MORTGAGE_TYPE_INTEREST_ONLY]: 'Interest-only',
    [MORTGAGE_TYPE_REPAYMENT]: 'Repayment',
}

export const STUDENT_PLAN_TYPE_ONE = 'PlanType1'
export const STUDENT_PLAN_TYPE_TWO = 'PlanType2'
export const STUDENT_PLAN_TYPE_ONE_AND_TWO = 'PlanType1And2'
export const STUDENT_PLAN_TYPE_OTHER = 'PlanTypeOther'

export const STUDENT_PLAN_TYPE_TITLES = {
    [STUDENT_PLAN_TYPE_ONE]: 'Plan 1',
    [STUDENT_PLAN_TYPE_TWO]: 'Plan 2',
    [STUDENT_PLAN_TYPE_ONE_AND_TWO]: 'Both plans',
    [STUDENT_PLAN_TYPE_OTHER]: 'Other',
}
